import Form from '../_form';

export default class ResetPasswordForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const form = document.querySelector(query);
        if (!form) return;

        const heading = document.querySelector('#reset-password-heading');
        if (!heading) throw new Error('Sign up heading element not found!');

        const staticImage = document.querySelector('#reset-password-image-static');
        if (!staticImage) throw new Error('Sign up image element not found!');

        const successImage = document.querySelector('#reset-password-image-success');
        if (!successImage) throw new Error('Sign up image element not found!');

        const success = document.querySelector('#reset-password-success');
        if (!success) throw new Error('Sign up success element not found!');

        this.success = success;
        this.successImage = successImage;
        this.staticImage = staticImage;
        this.heading = heading;
    }

    handleSuccess () {
        this.form.classList.add('hidden');
        this.success.classList.remove('hidden');
        this.heading.classList.add('hidden');
        this.staticImage.classList.add('hidden');
        this.successImage.classList.remove('hidden');
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const nonce = formData.get('reset_password_nonce');

        const email = formData.get('email');

        try {
            await fetch('/wp-json/auth/v1/reset-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ nonce, email })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully sent!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.handleSuccess();
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
